<template>
    <v-snackbar
        v-model="mostrar"
        :color="color"
        :bottom="position.y == 'bottom'"
        :top="position.y == 'top'"
        :right="position.x == 'right'"
        :left="position.x == 'left'"
        :centered="position.x == 'centered'"
        multi-line
        elevation="12"
        :timeout="3000"
    >
        <div class="title">
            {{msg}}
        </div>
        <template v-slot:action="{ attrs }">
            <v-icon
                v-bind="attrs"
            >
                {{color=="success"? 'mdi-check': (color=="error"? 'mdi-close' : 'mdi-delete')}}
            </v-icon>
        </template>
    </v-snackbar>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';

export default {
    data() {
        return({
            mostrar: false
        });
    },
    computed: {
        ...mapGetters('snackbar', ['model', 'color', 'position', 'msg'])
    },
    methods: {
        ...mapMutations('snackbar', ['setModel'])
    },
    mounted() {
        this.mostrar = this.model;
    },
    watch: {
        mostrar() {
            this.setModel(this.mostrar);
        },
        model() {
            this.mostrar = this.model;
        }
    }
}
</script>